import React from 'react';

const ScrollHint = () => {
  return <div className="ScrollHint" />;
};

export default ScrollHint;
